import { render } from "./CustomerSidenavs.vue?vue&type=template&id=4593dc00"
import script from "./CustomerSidenavs.vue?vue&type=script&lang=js"
export * from "./CustomerSidenavs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__